import * as Sentry from "@sentry/react";
import { getSentryConfig } from "./sentryConfig";

Sentry.init(getSentryConfig());
